import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getCommunities } from "../../../CrudOperations/GetOperation";

const ReserveDeputyForm = ({
  formData,
  setFormData,
  submitForm,
  onSuccess,
  editStaff,
}) => {
  const [communityList, setCommunityList] = useState([]);
  const [previewUrl, setPreviewUrl] = useState("");

  useEffect(() => {
    getCommunities().then((res) => {
      if (res?.data?.length > 0) {
        setCommunityList(res.data);
      } else {
        toast.error("Failed to load communities.");
      }
    });

    if (editStaff && editStaff.StaffImage) {
      setPreviewUrl(editStaff.StaffImage);
    }
  }, [editStaff]);

  const handleImageChange = (file) => {
    if (!file) return;

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64String = reader.result.split(",")[1];
      setFormData({ ...formData, StaffImage: base64String });
      setPreviewUrl(reader.result);
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await submitForm();
    onSuccess();
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* Input Fields */}
      {[
        { label: "Full Name", key: "FullName", type: "text" },
        { label: "Contact No", key: "ContactNo", type: "tel" },
        { label: "Department", key: "Department", type: "text" },
        { label: "Designation", key: "Designation", type: "text" },
        { label: "Address", key: "Address", type: "text" },
      ].map((field) => (
        <div key={field.key}>
          <label className="text-sm font-medium text-gray-700 block mb-1">
            {field.label} *
          </label>
          <input
            type={field.type}
            value={formData[field.key] || ""}
            onChange={(e) =>
              setFormData({ ...formData, [field.key]: e.target.value })
            }
            className="w-full border px-3 py-2 rounded-md text-sm"
            required
          />
        </div>
      ))}

      {/* Gender */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Gender *</label>
        <select
          value={formData.Gender}
          onChange={(e) => setFormData({ ...formData, Gender: e.target.value })}
          className="w-full border px-3 py-2 rounded-md text-sm"
          required
        >
          <option value="Male">Male</option>
          <option value="Female">Female</option>
        </select>
      </div>

      {/* Community */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Community *</label>
        <select
          value={formData.CommunityId}
          onChange={(e) =>
            setFormData({ ...formData, CommunityId: parseInt(e.target.value) })
          }
          className="w-full border px-3 py-2 rounded-md text-sm"
          required
        >
          <option value="">Select</option>
          {communityList.map((commu) => (
            <option key={commu.CommunityId} value={commu.CommunityId}>
              {commu.CommunityName}
            </option>
          ))}
        </select>
      </div>

      {/* Availability */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Availability *</label>
        <select
          value={formData.isAvailable || 1}
          onChange={(e) =>
            setFormData({ ...formData, isAvailable: parseInt(e.target.value) })
          }
          className="w-full border px-3 py-2 rounded-md text-sm"
          required
        >
          <option value={1}>Available</option>
          <option value={0}>Unavailable</option>
        </select>
      </div>

      {/* Image Upload */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Photo</label>
        <input
          type="file"
          accept="image/*"
          onChange={(e) => handleImageChange(e.target.files[0])}
          className="w-full border px-3 py-2 rounded-md text-sm"
        />
        {previewUrl && (
          <div className="mt-2">
            <img
              src={previewUrl}
              alt="Preview"
              className="w-24 h-24 rounded object-cover border"
            />
          </div>
        )}
      </div>

      {/* Submit Button */}
      <button
        type="submit"
        className="w-full bg-blue-600 text-white py-2 rounded-md mt-4 hover:bg-blue-700"
      >
        {editStaff ? "Update Deputy" : "Add Deputy"}
      </button>
    </form>
  );
};

export default ReserveDeputyForm;
